import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './app/App';
import { preloadCurrentRoute } from './app/router';
import { Providers } from './app/providers';
import './styles/index.css';
import { getAdConfig } from './config/ads';
import { initializeRealUserMonitoring } from './lib/rum';

if (getAdConfig().debug) document.documentElement.dataset.adDebug = 'true';
initializeRealUserMonitoring();

const root = document.getElementById('root');
if (!root) throw new Error('SolarGabay root element is missing.');

const application = (
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);

if (root.hasChildNodes()) {
  void preloadCurrentRoute(window.location.pathname).then(() => hydrateRoot(root, application));
} else {
  createRoot(root).render(application);
}
